// SEO config per service - controls <title>, meta description, keywords, Service schema
export const SEO_CONFIG = {
  "ramen-wassen": {
    title: "Ramenwasser Leuven | Glazenwasser & Ramen wassen - Fresh View",
    description: "Professionele ramenwasser in Leuven en Aarschot. Streeploos resultaat met osmosewater. Voor particulieren en bedrijven. Vraag uw gratis offerte aan.",
    keywords: "ramenwasser Leuven, glazenwasser Leuven, ramen wassen Leuven, professionele ramenwasser, ramenwasser bedrijf, ramenwasser particulier, ramen laten wassen, ramenwasser Aarschot, ramenwasser nabij mij, ramen poetsen prijs, ramen reinigen kantoor, ramen wassen prijs",
    h1: "Ramenwasser in Leuven: streeploos resultaat met osmosewater",
    serviceType: "Window Cleaning",
    serviceName: "Ramen wassen",
    aliases: ["/ramenwassen-leuven", "/glazenwasser-leuven", "/ramen-wassen-leuven"],
  },
  "dakreiniging": {
    title: "Dakreiniging & Mos verwijderen Leuven | Fresh View",
    description: "Dakreiniging in Leuven, Aarschot en omstreken. Softwash mos- en algenverwijdering, zonder schade aan dakpannen. Inclusief dakgootreiniging. Gratis offerte.",
    keywords: "dakreiniging Leuven, dak reinigen, mos verwijderen dak, softwash, dakgoot reinigen Leuven, dakgootreiniging, dakpannen reinigen, algen verwijderen dak, dakreiniging Aarschot, dakreiniging prijs",
    h1: "Dakreiniging in Leuven: mos en algen veilig verwijderd",
    serviceType: "Roof Cleaning",
    serviceName: "Dakreiniging",
    aliases: ["/dakreiniging-leuven", "/dak-reinigen-leuven", "/dakgoot-reiniging-leuven"],
  },
  "zonnepaneel-schoonmaak": {
    title: "Zonnepanelen reinigen Leuven | Tot 30% meer rendement - Fresh View",
    description: "Zonnepanelen laten reinigen in Leuven en Aarschot. Tot 30% meer opbrengst door professionele reiniging met gedemineraliseerd water. Vraag gratis offerte.",
    keywords: "zonnepanelen reinigen Leuven, zonnepaneel schoonmaak, zonnepanelen laten reinigen, zonnepanelen wassen, panelen reinigen rendement, zonnepanelen onderhoud, zonnepanelen reinigen prijs, zonnepanelen reinigen Aarschot",
    h1: "Zonnepanelen reinigen in Leuven: tot 30% meer opbrengst",
    serviceType: "Solar Panel Cleaning",
    serviceName: "Zonnepanelen reinigen",
    aliases: ["/zonnepanelen-reinigen-leuven", "/zonnepanelen-leuven", "/zonnepaneel-schoonmaak-leuven"],
  },
  "gevel-reiniging": {
    title: "Gevelreiniging & Oprit reinigen Leuven | Fresh View",
    description: "Gevelreiniging en opritreiniging in Leuven en Aarschot. Klinkers, terrassen, baksteen en crepi grondig gereinigd zonder schade. Gratis offerte op maat.",
    keywords: "gevelreiniging Leuven, oprit reinigen Leuven, opritreiniging, terras reinigen, klinkers reinigen, baksteen reinigen, crepi reinigen, gevelreiniging prijs, opritreiniging Aarschot, gevel laten reinigen",
    h1: "Gevel- en opritreiniging in Leuven: grondig en zonder schade",
    serviceType: "Pressure Washing",
    serviceName: "Gevel- en opritreiniging",
    aliases: ["/gevelreiniging-leuven", "/opritreiniging-leuven", "/oprit-reinigen-leuven"],
  },
};

export const updateMetaTags = ({ title, description, keywords, canonicalPath = "" }) => {
  if (title) document.title = title;

  const setMeta = (name, content, isProperty = false) => {
    const attr = isProperty ? "property" : "name";
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  if (description) {
    setMeta("description", description);
    setMeta("og:description", description, true);
    setMeta("twitter:description", description);
  }
  if (keywords) setMeta("keywords", keywords);
  if (title) {
    setMeta("og:title", title, true);
    setMeta("twitter:title", title);
  }

  // canonical
  if (canonicalPath !== undefined) {
    const fullUrl = `https://www.freshview.be${canonicalPath}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", fullUrl);
    setMeta("og:url", fullUrl, true);
  }
};

export const injectServiceSchema = (config, serviceId) => {
  // Remove old service schema if any
  const old = document.getElementById("service-schema-jsonld");
  if (old) old.remove();

  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": config.serviceType,
    "name": config.serviceName,
    "description": config.description,
    "provider": {
      "@type": "LocalBusiness",
      "name": "Fresh View",
      "telephone": "+32494614295",
      "url": "https://www.freshview.be",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Leuven",
        "addressRegion": "Vlaams-Brabant",
        "addressCountry": "BE",
      },
    },
    "areaServed": [
      { "@type": "City", "name": "Leuven" },
      { "@type": "City", "name": "Aarschot" },
      { "@type": "City", "name": "Tienen" },
      { "@type": "City", "name": "Diest" },
    ],
    "url": `https://www.freshview.be/diensten/${serviceId}`,
  };

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = "service-schema-jsonld";
  script.text = JSON.stringify(schema);
  document.head.appendChild(script);
};
